import { getAppConfig } from 'App'
import { v4 as uuid } from 'uuid'

export const scripts = () => {
  const newUuid = uuid()
  const {
    ids: { gtm: gtmId, zendeskKey },
    features: {
      antiFlickerEnabled,
      ssoGoogleEnabled,
      applePayEnabled,
      chatbotEnabled,
      chatbotProvider,
    },
  } = getAppConfig()
  return [
    {
      shouldLoad: antiFlickerEnabled,
      appendAt: 'head',
      execute: () => {
        const immediateFunction = (a, s, y, n, c, h, i, d, e) => {
          s.className += ' ' + y
          h.start = 1 * new Date()
          h.end = i = function () {
            s.className = s.className.replace(RegExp(' ?' + y), '')
          }
          ;(a[n] = a[n] || []).hide = h
          setTimeout(function () {
            i()
            h.end = null
          }, c)
          h.timeout = c
        }
        immediateFunction(
          window,
          document.documentElement,
          'async-hide',
          'dataLayer',
          4000,
          {
            [gtmId]: true,
          }
        )
      },
    },
    {
      shouldLoad: ssoGoogleEnabled,
      appendAt: 'body',
      scriptProperties: {
        async: true,
        src: 'https://accounts.google.com/gsi/client',
        defer: true,
      },
    },
    {
      shouldLoad: applePayEnabled,
      appendAt: 'head',
      scriptProperties: {
        src: 'https://applepay.cdn-apple.com/jsapi/v1.1.0/apple-pay-sdk.js',
      },
    },

    {
      shouldLoad:
        chatbotEnabled &&
        (chatbotProvider === 'zendesk' ||
          chatbotProvider === '' ||
          chatbotProvider === null),
      appendAt: 'head',
      scriptProperties: {
        nonce: newUuid,
        id: 'ze-snippet',
        src: `https://static.zdassets.com/ekr/snippet.js?key=${zendeskKey}`,
      },
    },
  ]
}
